import { render, staticRenderFns } from "./Sprc.vue?vue&type=template&id=3934ff88&scoped=true&"
import script from "./Sprc.vue?vue&type=script&lang=js&"
export * from "./Sprc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3934ff88",
  null
  
)

export default component.exports